const initialState = {
    currentPage: 'index-page',
    isPreloaderActive: false,
    currentPhoto: false,
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    dlNumber: '',
    expDate: '',
    country: 'NL',
    categoryB: true,
    selfie: false,
    documents: {
        dlFront: '',
        dlBack: '',
        passport: '',
        idCardFront: '',
        idCardBack: ''
    },
    zipCodeLiving: '',
    houseNumberLiving: '',
    numberAdditionLiving: '',
    streetLiving: '',
    cityLiving: '',
    zipCodeInvoice: '',
    houseNumberInvoice: '',
    numberAdditionInvoice: '',
    streetInvoice: '',
    cityInvoice: '',
    countryLiving: 'NL',
    countryInvoice: 'NL',
    email: '',
    phone: '',
    need24password: true,
    password: '',
    repassword: '',
    theSameInvoice: false,
    error: {
        isActive: false,
        title: '',
        message: ''
    },
    idcardpasNumber: '',
    idcardpasExpdate: '',
    idcardpasCountry: 'DE',
    login: {
        isActive: false,
        title: '',
        message: ''
    },
    language: 'nl',
    lang: {}
}

const reducer = (state = initialState, action) => {
    switch (action.type) {

        case 'HIDE_ERROR_MESSAGE':
            return {
                ...state,
                error: {
                    ...state.error,
                    title: '',
                    message: '',
                    isActive: false
                }
            }

        case 'SHOW_ERROR_MESSAGE':
            return {
                ...state,
                error: {
                    isActive: true,
                    title: action.payload.title,
                    message: action.payload.message
                }
            }

        case 'SHOW_LOGIN_POPUP':
            return {
                ...state,
                login: {
                    ...state.login,
                    isActive: true,
                }
            }

        case 'HIDE_LOGIN_POPUP':
            return {
                ...state,
                login: {
                    isActive: false
                }
            }

        case 'CHANGE_FIELD':
            return {
                ...state,
                [action.payload.field]: action.payload.value
            }

        case 'CHANGE_DL_FRONT_PAGE_RESULT':
            return {
                ...state,
                currentPage: 'dl-front-page-result',
                currentPhoto: action.payload,
                documents: {
                    ...state.documents,
                    dlFront: action.payload
                }
            }

        case 'CHANGE_DL_BACK_PAGE_RESULT':
            return {
                ...state,
                currentPage: 'dl-back-page-result',
                currentPhoto: action.payload,
                documents: {
                    ...state.documents,
                    dlBack: action.payload
                }
            }

        case 'CHANGE_PASSPORT_PAGE_RESULT':
            return {
                ...state,
                currentPage: 'passport-photo-result-page',
                currentPhoto: action.payload,
                documents: {
                    ...state.documents,
                    passport: action.payload
                }
            }

        case 'CHANGE_ID_CARD_FRONT_PAGE_RESULT':
            return {
                ...state,
                currentPage: 'idcard-front-result-page',
                currentPhoto: action.payload,
                documents: {
                    ...state.documents,
                    idCardFront: action.payload
                }
            }

        case 'CHANGE_ID_CARD_BACK_PAGE_RESULT':
            return {
                ...state,
                currentPage: 'idcard-back-result-page',
                currentPhoto: action.payload,
                documents: {
                    ...state.documents,
                    idCardBack: action.payload
                }
            }

        case 'CHANGE_SELFIE_RESULT':
            return {
                ...state,
                currentPage: 'selfie-result-page',
                currentPhoto: action.payload,
                selfie: action.payload
            }

        default:
            return state
    }
}

export default reducer